import React from 'react';
import cx from 'classnames';
import { View } from '@dbk/ui-react-utils';
import Text from '@dbk/ui-text';
import './blur-modal-header.css';

export default function Header({ title, children, className, ...other }) {
  return (
    <View {...other}>
      <View className={cx(className, 'ModalHeader')}>
      <Text size="large" tabIndex={title ? 0 : -1} style={{ color: '#fff', lineHeight: 4.5 }}>{title}</Text>
        <View className={cx(className, 'HorizontalRule')} />
        {children}
      </View>
    </View>
  );
}
